module.exports = __webpack_public_path__ + "img/score_6.793c904c.png";